import { render, staticRenderFns } from "./LoaderGeneral.vue?vue&type=template&id=cf1d3026&scoped=true&"
import script from "./LoaderGeneral.vue?vue&type=script&lang=js&"
export * from "./LoaderGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf1d3026",
  null
  
)

export default component.exports